<script>
</script>

<div class="container">
  <div class="content title">예약일정</div>
  <div class="content desc">예약은 상담 후 진행됩니다.</div>
  <div class="content calendar-wrapper">
    <!-- 탁 캘린더 -->
    <iframe
      src="https://calendar.google.com/calendar/embed?src=85agrt9rec3ic7nk171qnf3mgc%40group.calendar.google.com&ctz=Asia%2FSeoul"
      class="content calendar"
      style="border: 0"
      frameborder="0"
      scrolling="no"
    />

    <!-- 내 캘린더 -->
    <!-- <iframe
      src="https://calendar.google.com/calendar/embed?src=0avdfjol7jfo361grcj3gc32gc%40group.calendar.google.com&ctz=Asia%2FSeoul"
      class="content calendar"
      style="border: 0"
      frameborder="0"
      scrolling="no"
    /> -->
  </div>
</div>

<style>
  .container {
    width: 100%;
    height: 800px;
  }
  .content {
    width: 100%;
  }

  .content.title,
  .content.desc {
    text-align: center;
    margin: 0;
    margin-bottom: 20px;
  }
  .content.title {
    font-weight: 400;
    font-size: 30px;
  }
  .content.desc {
    font-weight: 200;
    font-size: 24px;
  }
  .content.calendar-wrapper {
    margin: 0;
    width: 100%;
    height: 620px;
    overflow: hidden;
    box-shadow: 1px 1px 1px #ccc;
  }
  .content.calendar {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media screen and (max-width: 768px) {
    .container {
      width: 100%;
      height: 80vh;
    }
    .content.calendar-wrapper {
      height: 50vh;
    }
  }
</style>
